import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../contexts/LanguageContext';
import { projects } from '../../data/mockData';
import { EASE_OUT } from '../../utils/motion';
import { AppSidebar } from './AppSidebar';
export function SystemMock() {
  const {
    t
  } = useLanguage();
  const s = t.ui.system;
  return <div className="flex text-left" aria-hidden="true" data-id="element-94" data-mp="3ierh646j2rdh">
      <AppSidebar active={0} data-id="element-95" data-mp="2uo5jn6u5gphq" />
      <div className="min-w-0 flex-1 p-4 md:p-6" data-id="element-96" data-mp="2upgn15jonv8b">
        <div className="mb-5 flex items-center gap-3" data-id="element-97" data-mp="2qn26is3hl7k7">
          <span className="text-[15px] font-semibold text-white md:text-lg" data-id="element-98" data-mp="2qomyqb2bweew">
            {s.title}
          </span>
          <span className="rounded-full bg-cyan/10 px-2 py-0.5 text-[10px] font-medium text-cyan" data-id="element-99" data-mp="34fruv36hmokh">
            {s.active}
          </span>
        </div>

        <div className="overflow-hidden rounded-lg border border-white/[0.06]" data-id="element-100" data-mp="2bxe3nmfnq0ud">
          <div className="grid grid-cols-[92px_repeat(5,1fr)] gap-1.5 border-b border-white/[0.06] px-3 py-2 text-[9px] text-white/40 md:grid-cols-[150px_repeat(5,1fr)] md:gap-2 md:text-[11px]" data-id="element-101" data-mp="26zci8uurdpfq">
            <span data-id="element-102" data-mp="1rqdfitw6y8p4" />
            {s.stages.map(stage => <span key={stage} className="truncate" data-id="element-103" data-mp="1rosmx9tfsztw">
                {stage}
              </span>)}
          </div>
          {projects.map((project, ri) => <div key={project.name} className="grid grid-cols-[92px_repeat(5,1fr)] items-center gap-1.5 border-b border-white/[0.06] px-3 py-3 last:border-0 md:grid-cols-[150px_repeat(5,1fr)] md:gap-2 md:py-3.5" data-id="element-104" data-mp="21fexuqq7l269" data-mpi={ri}>
              <span className="truncate text-[11px] text-white/85 md:text-[12px]" data-id="element-105" data-mp="1dqvo06righc2">
                {project.name}
              </span>
              {s.stages.map((stage, ci) => <motion.div key={stage} initial={{
            scaleX: 0
          }} whileInView={{
            scaleX: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: ri * 0.08 + ci * 0.04,
            ease: EASE_OUT
          }} style={{
            originX: 0
          }} className={`h-2 rounded-full ${ci < project.stage ? 'bg-cyan' : ci === project.stage ? 'animate-pulse bg-cyan/40' : 'bg-white/[0.06]'}`} data-id="element-106" data-mp="1hqcth06xteh8" data-mpi={ci} />)}
            </div>)}
        </div>

        <div className="mt-4 grid grid-cols-3 gap-2 md:gap-3" data-id="element-107" data-mp="y5ixpo4p66lw">
          {s.stats.map(stat => <div key={stat.label} className="rounded-lg bg-white/[0.03] p-3" data-id="element-108" data-mp="afwvsswxxda7">
              <div className="text-lg font-semibold tracking-tight text-white md:text-2xl" data-id="element-109" data-mp="6dtidyqpnyma">
                {stat.value}
              </div>
              <div className="mt-0.5 text-[10px] leading-tight text-white/45 md:text-[11px]" data-id="element-110" data-mp="k5zp6u7z4t92">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}